module.exports = __webpack_public_path__ + "img/mailchimp-icon.953fd737.svg";